export class HardcodedOrganisations {
  // These two hard-coded IDs will come with the migrations
  static readonly PROJECT_RE_ORG_ID: string = '365b6706-b6d0-11eb-8529-0242ac130003';
  static readonly PLATFORM_CONTACT_ID: string = '7e709e1a-b6c3-11eb-8529-0242ac130003';
}
